import { Component, OnInit } from '@angular/core';
import { FormGroup,FormBuilder, Validators } from '@angular/forms';
import { MapsAPILoader } from "@agm/core";
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { Image } from '../../../../../images/images'
import { BranchService } from 'src/app/shared/API-Service/services/branch.service';
import { CityService } from 'src/app/shared/API-Service/services/city.service';
import { GovernorateService } from 'src/app/shared/API-Service/services/governorate.service';

import { getParseErrors } from '@angular/compiler';


@Component({
  selector: 'app-insert-branch',
  templateUrl: './insert-branch.component.html',
  styleUrls: ['./insert-branch.component.css']
})
export class InsertBranchComponent implements OnInit {
   
  cairolong ;
  cairolat ;
  zoom:number = 5 ;
  lat ;
  long ;
  recordtoupdate: any;
  city:any ;
  branchForm : FormGroup;
branchFormData : FormData;
update:boolean = false;
button:boolean = false;
Image: File;
imageLogo: string;
img : string = Image;
  getAddress: any;
  apiloader: any;
  GovernateId: any;
  Governorates: any;



  constructor(private GovernorateService : GovernorateService,private _BranchService:BranchService,private _Router:Router,private _FormBuilder:FormBuilder, private _CityService:CityService) { 
    this.currentlocation();
    this.imageLogo="../../../../../assets/images/upload.png"
  }

  ngOnInit(): void {
    this.initiate();
    this.getGovernorate();
    this.checkEdit();
  }
  
  GetCityByGovernorateId(GovernorateId){
  console.log(GovernorateId)
this._CityService.GetCityByGovernorateId(GovernorateId).subscribe((res) => {
  this.city = res.data;
  console.log(this.city)
},(err) => {
  console.log('their is a problem with cities ');
},() =>{
  console.log('completed');
})
}
getGovernorate(){
this.GovernorateService.GetGovernorate().subscribe(res=>{
  this.Governorates=res.data;
})
}
SelectedGovernorate(event){
  console.log(event)
  this.city=[];
  this.branchForm.get('cityId').reset();
  this.GovernateId=event;
  this.GetCityByGovernorateId(this.GovernateId);
}
currentlocation(){
  this._BranchService.getcurrentlocation().then(resp => {
    this.cairolat = resp.lat;
    this.cairolong = resp.lng;
    this.lat =resp.lat;
  this.long =resp.lng;
    console.log(this.cairolat + 'i am here ');
    console.log(this.cairolong);
    
   })
}

  initiate(){
    this.branchForm = this._FormBuilder.group({
      title: ['', Validators.required],
      phone: ['', [Validators.required, Validators.pattern(`^01[0125]{1}[0-9]{8}`)]],
      address : ['', Validators.required],
      cityId : ['', Validators.required],
      GovernorateId: ['', Validators.required],
      BranchManager : ['', Validators.required],
      MapLink : [''],
      branchImage : ['', Validators.required],
    });
    this.currentlocation();
  }

  
  checkEdit() {
    this.zoom = 15;
    this._BranchService.Data.subscribe((res) => {
      if (res != null) {
        console.log(res)
        this.GetCityByGovernorateId(res.governorateId)
        this.branchForm = this._FormBuilder.group({
          title: [res.title, Validators.required],
          phone: [res.phone,  [Validators.required, Validators.pattern(`^01[0125]{1}[0-9]{8}`)]],
          address: [res.address, Validators.required],
          cityId : [res.cityId, Validators.required],
          GovernorateId : [res.governorateId, Validators.required],
          MapLink : [res.mapLink],
          BranchManager : [res.branchManager, Validators.required],
          branchImage : [res.image]
        });
       
        this.cairolat = this.branchForm.value.lat;
        this.lat = this.branchForm.value.lat;
        this.long = this.branchForm.value.long;
        this.cairolong = this.branchForm.value.long;
        this.imageLogo = this.img + res.image;
        
        // let driver = this.getById(res);
        this.update = true;
        this.recordtoupdate = res ;
       
      } else {
        console.log(`not found on data`);
        // this.initiate();
      }
     
    });
  }
  insertappenddata(){
    this.branchFormData = new FormData();
    this.branchFormData.append("Title", this.branchForm.value.title);
    this.branchFormData.append("Phone", this.branchForm.value.phone);
    this.branchFormData.append("Address", this.branchForm.value.address);
    this.branchFormData.append("CityId", this.branchForm.value.cityId);
    this.branchFormData.append("BranchManager",this.branchForm.value.BranchManager);
    this.branchFormData.append("MapLink",this.branchForm.value.MapLink);
    this.branchFormData.append("BranchImage", this.Image);
    // this.branchFormData.append("Lat", this.lat);
    // this.branchFormData.append("Long", this.long);
  }
    updateappenddata(){
      this.branchFormData = new FormData();
      this.branchFormData.append("Title", this.branchForm.value.title);
      this.branchFormData.append("Phone", this.branchForm.value.phone);
      this.branchFormData.append("Address", this.branchForm.value.address);
      this.branchFormData.append("CityId", this.branchForm.value.cityId);
      // this.branchFormData.append("Lat", this.lat);
      // this.branchFormData.append("Long", this.long);
      this.branchFormData.append("BranchManager",this.branchForm.value.BranchManager);
      this.branchFormData.append("MapLink",this.branchForm.value.MapLink);
      this.branchFormData.append("BranchImage",this.Image);
      this.branchFormData.append("Id", this.recordtoupdate.id);
    }
      // imgFile
  getLogoUrl(event: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      this.Image = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imageLogo = reader.result as string;
        // this.logoForm?.append("image", this.Image);
      };
    }
  }
  get fc() {
    return this.branchForm.controls;
  }

  onSubmit(){
    this.button = true;
   if(this.update == false && this.branchForm.status == "VALID" ){
    console.log(typeof(this.long));
    this.insertappenddata()
    this._BranchService.Createbranch(this.branchFormData).subscribe((res) => {
      Swal.fire({
        icon: "success",
        title: "تم الحفظ بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });
      this.branchForm.reset();
      this._Router.navigate(['/content/admin/ViewBranch']);
    },(err) => {
      Swal.fire({
        icon: 'error',
        title: 'خطأ',
        text:err.message    
      }) 
      this.button = false ;
    }, () => {
      console.log('completed ');
    })
   } else if(this.branchForm.status == "VALID" ){
    this.updateappenddata()
    this._BranchService.Updatebranch(this.branchFormData).subscribe((res) => {
      Swal.fire({
        icon: "success",
        title: "تم التعديل بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });
      this.branchForm.reset();
      this._Router.navigate(['/content/admin/ViewBranch']);
    },(err) => {
      Swal.fire({
        icon: 'error',
        title: 'خطأ',
        text:err.message    
      }) 
    }, () => {
      console.log('completed ');
    })
   }else {
    Swal.fire({
      icon: 'error',
      title: 'خطأ',
      text:"بالرجاء التأكد من ملئ جميع الحقول"   
    })
    this.branchForm.markAllAsTouched();
    this.button = false;
   }
  }
  ngOnDestroy(){
    this._BranchService.Data.next(null);
     }


 


}
